import { Controller } from "@hotwired/stimulus"

// Toast item: auto-dismiss after duration (seconds), dismiss with exit animation on close click.
export default class extends Controller {
  static values = { duration: { type: Number, default: 0 } }

  connect() {
    // Trigger enter animation (remove initial class after paint)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.element.classList.remove("toast-item-enter"))
    })
    if (this.durationValue > 0) {
      this.autoDismissTimeout = setTimeout(() => this.dismiss(), this.durationValue * 1000)
    }
  }

  disconnect() {
    if (this.autoDismissTimeout) clearTimeout(this.autoDismissTimeout)
  }

  dismiss() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout)
      this.autoDismissTimeout = null
    }
    this.element.classList.add("toast-item-exit")
    const onEnd = () => this.element.remove()
    const handleTransitionEnd = (e) => {
      if (e.propertyName === "max-height") onEnd()
    }
    this.element.addEventListener("transitionend", handleTransitionEnd, { once: true })
    setTimeout(onEnd, 450)
  }
}
